import { Link } from 'react-router-dom';
import type { ComicItem } from '@/mocks/comics';

interface ComicCardProps {
  comic: ComicItem;
  size?: 'small' | 'medium' | 'large';
  showRank?: boolean;
  rank?: number;
}

export default function ComicCard({ comic, size = 'medium', showRank = false, rank }: ComicCardProps) {
  const coverSizes = {
    small: 'w-[100px] h-[140px]',
    medium: 'w-[140px] h-[196px]',
    large: 'w-[180px] h-[252px]',
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
    >
      <div className="relative overflow-hidden rounded-lg">
        <div className={`${coverSizes[size]} relative overflow-hidden rounded-lg`}>
          <img
            src={comic.coverImage}
            alt={comic.title}
            title={`${comic.title} - 亲亲漫画免费在线阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

          {showRank && rank && rank <= 3 && (
            <div className="absolute top-0 left-0 w-7 h-7 flex items-center justify-center rounded-br-lg bg-primary-500 text-background-50 text-xs font-bold">
              {rank}
            </div>
          )}
          {showRank && rank && rank > 3 && (
            <div className="absolute top-0 left-0 w-7 h-7 flex items-center justify-center rounded-br-lg bg-background-900/70 text-background-50 text-xs font-bold">
              {rank}
            </div>
          )}

          {comic.isHot && !showRank && (
            <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-[10px] font-semibold">
              热门
            </span>
          )}
          {comic.isNew && !showRank && (
            <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-semibold">
              新作
            </span>
          )}

          <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
            <span className="inline-block px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-[10px] font-medium">
              {comic.latestChapter}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
          {comic.title}
        </h3>
        {size !== 'small' && (
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-foreground-500">{comic.category}</span>
            <span className="text-[10px] text-foreground-400">·</span>
            <span className="text-xs text-foreground-500">{comic.author}</span>
          </div>
        )}
        {size === 'large' && (
          <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">
            {comic.description}
          </p>
        )}
      </div>
    </Link>
  );
}